import { useEffect, useMemo, useState } from 'react';
import type { NFLTeamInputs } from '@library/types/simulations';
import { NumberInput } from '@library/components/inputs';
import { classNames } from '@library/utils';
import { withinMinMax } from '@bo-utils/simulations';

export const TeamNumberOverride = ({
  currentValue,
  field,
  min = undefined,
  max = undefined,
  onBlur,
  onSetTeamInputs
}: {
  currentValue: number | '';
  field: keyof NFLTeamInputs;
  min?: number;
  max?: number;
  onBlur: (field: keyof NFLTeamInputs) => void;
  onSetTeamInputs: (
    key: keyof NFLTeamInputs,
    value: number | string | boolean
  ) => void;
}) => {
  const handleChangeNumber = useMemo(
    () => (inputValue: string) => {
      onSetTeamInputs(
        field,
        inputValue !== '' ? Number(inputValue) : inputValue
      );
    },
    [field, onSetTeamInputs]
  );

  const [value, setValue] = useState<string>(String(currentValue));

  useEffect(() => {
    if (String(currentValue) !== value) {
      handleChangeNumber(value);
    }
  }, [currentValue, handleChangeNumber, value]);

  const inputValidationFailed = useMemo(
    () => withinMinMax({ currentValue, minimum: min, maximum: max }),
    [max, min, currentValue]
  );

  return (
    <NumberInput
      className={classNames(
        'font-heebo text-soClean-100 disabled:text-soClean-160 border-soFresh-140 h-8 w-16 justify-self-center rounded-md bg-transparent px-0 text-center text-sm font-medium leading-5 tracking-tight',
        inputValidationFailed ? 'border-roses focus:border-roses' : ''
      )}
      onBlur={() => onBlur(field)}
      onValueChange={(inputValue) => setValue(inputValue)}
      value={value}
    />
  );
};
